export const RestaurantListEmpty = () => {
  return (
    <div className="min-h-[50vh] bg-accent/50 rounded-lg flex flex-col items-center justify-center text-muted-foreground p-8 animate-in fade-in-50">
      <h3 className="text-xl font-semibold mb-2">No Results Found</h3>
      <p className="text-center max-w-md">
        Try adjusting your filters or search criteria to find more restaurants
      </p>
    </div>
  );
};